"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsText = exports.DetailsContainer = exports.ItemCountText = exports.PercentageText = exports.ProgressTextContainer = exports.ProgressContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const getSizes = (size) => ({
    container: `${size}px`,
    padding: `${Math.max(8, size * 0.06)}px`,
    primaryText: `${Math.max(14, size * 0.1)}px`,
    secondaryText: `${Math.max(10, size * 0.08)}px`,
});
exports.ProgressContainer = (0, styled_components_1.default)(material_1.Box) `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => getSizes($size).container};
  height: ${({ $size }) => getSizes($size).container};
`;
exports.ProgressTextContainer = (0, styled_components_1.default)(material_1.Box) `
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${({ $size }) => getSizes($size).padding};
`;
exports.PercentageText = (0, styled_components_1.default)(material_1.Typography) `
  font-weight: 700;
  font-size: ${({ $size }) => getSizes($size).primaryText};
  line-height: 1;
  color: ${({ theme }) => theme.palette.text.primary};
`;
exports.ItemCountText = (0, styled_components_1.default)(material_1.Typography) `
  font-weight: 400;
  font-size: ${({ $size }) => getSizes($size).secondaryText};
  line-height: 1.2;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin-top: 2px;
`;
exports.DetailsContainer = (0, styled_components_1.default)(material_1.Box) `
  margin-top: 16px;
  text-align: center;
`;
exports.DetailsText = (0, styled_components_1.default)(material_1.Typography) `
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
  line-height: 1.4;
`;
